import { addDays } from 'date-fns';
import { useQuery } from 'react-query';
import { Pagination } from '../../../../../../types/Common';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { AdvisoryReport } from '../../../types/AdvisoryReport';
import { AdvisoryReportOverviewFilterValues } from '../types/Filter';

interface Params {
  filters: Partial<AdvisoryReportOverviewFilterValues>;
  page?: number;
  pagelen?: number;
  query?: string;
}

export const ADVISORY_REPORTS_PAGE_LEN = 10;

export interface AdvisoryReportsResponse {
  pagination: Pagination;
  items: AdvisoryReport[];
}

const getAdvisoryReports = async ({
  page = 1,
  pagelen = ADVISORY_REPORTS_PAGE_LEN,
  query,
  filters,
}: Params) => {
  const { data, isError } = await wgApi.get<AdvisoryReportsResponse>(
    `v1/api/advisory-reports`,
    {
      query: {
        page,
        q: query,
        pagelen,
        order_by: 'created_at',
        created_at_ge:
          filters?.date?.[0] && addDays(filters?.date[0], 1)?.toISOString(),
        created_at_le:
          filters?.date?.[1] && addDays(filters?.date[1], 1)?.toISOString(),
        status: filters?.status,
        assigned_to: filters?.assignedTo,
        party_id: filters?.party,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getUseAdvisoryReportsBaseQKey = () => [
  'advisory-reports',
  'overview',
];

export const getUseAdvisoryReportsQKey = (params?: Params) => [
  ...getUseAdvisoryReportsBaseQKey(),
  params,
];

export const useAdvisoryReports = (params: Params) => {
  return useQuery(
    getUseAdvisoryReportsQKey(params),
    () => getAdvisoryReports(params),
    {
      refetchOnWindowFocus: false,
    },
  );
};

export const useAdvisoryReportsByParty = (partyId?: string) => {
  return useQuery(
    getUseAdvisoryReportsQKey({ filters: { party: partyId || null } }),
    () => getAdvisoryReports({ filters: { party: partyId || null } }),
    {
      refetchOnWindowFocus: false,
      enabled: !!partyId,
    },
  );
};
